// The battle code. md: one compact pill. xl: one tile per character, like a lock code, easy to read off a stream.
export function CodeBadge({ code, size = 'md', className = '' }: { code: string; size?: 'md' | 'xl'; className?: string }) {
  const chars = (code || '').toUpperCase().split('');
  if (size === 'xl') {
    return (
      <span className={`inline-flex ${className}`}>
        <span className="sr-only">Battle code {chars.join(' ')}</span>
        <span className="rd-code text-4xl sm:text-5xl" aria-hidden="true">{chars.map((c, i) => <span key={i}>{c}</span>)}</span>
      </span>
    );
  }
  return (
    <span className={`numeral inline-flex items-center rounded-[12px] border-2 border-line bg-surface px-3 py-1.5 text-xl tracking-[0.18em] text-ink shadow-[0_3px_0_var(--line-strong)] ${className}`}
      aria-label={`Battle code ${chars.join(' ')}`}>
      {chars.join('')}
    </span>
  );
}
